import React from "react";
import { activateDoctorFee, deactivateDoctorFee, getDoctorFees } from "./api";
import { refreshFees } from "./store/FeeReducer";
import Loader from "src/components/Dashboard/common/Loader";
import { useStore } from "./store/Store";
import { snackbar } from "@mobiscroll/react5";

const StatusCellRenderer = (params) => {
  const [loader, setLoader] = React.useState(false);
  const { globalState, dispatch } = useStore();


  const handleChange = async (e) => {
    setLoader(true);
    try {
      if (e.target.checked) {
        await activateDoctorFee({ doctorId: params.data.doctorId, id: params.data.id, });
        await fetchData();
      } else {
        await deactivateDoctorFee({ doctorId: params.data.doctorId, id: params.data.id, });
        await fetchData(params.data.doctorId);
      }
    } catch (err) {
      snackbar({ message: "Error occured while updating Fee. Try again", color: "danger", });
      console.error("Error at update doctor fee: ", err);
    }
    setLoader(false);
  };

  const fetchData = async () => {
    try {
      const res = await getDoctorFees();
      dispatch(refreshFees(res));
    }
    catch (error) {
      console.error("Error fetching doctor fees: ", error);
    }
  }

  return (
    <>
      <Loader show={loader} />
      <label className="switch">
        <input
          type="checkbox"
          checked={params.value === "Inactive" ? false : true}
          onChange={handleChange}
        />
        <span className="slider active slider-po-show round"></span>
      </label>
    </>
  );
};

export default StatusCellRenderer;
